<div
  *ngIf="form && controlName && controlNameSelector && label"
  [formGroup]="form"
  class="timepicker-wrapper"
  dropdown
  [autoClose]="false"
  #time="bs-dropdown"
  (onShown)="onDropdownShown()"
  (onHidden)="onHideTime()"
>
  <div class="{{ className }}">
    <label for="{{ controlName }}">{{ label }}</label>
    <input
      readonly
      id="{{ controlName }}"
      dropdownToggle
      class="form-control"
      placeholder="{{ showHoursOnly ? appConfig.Formats.TimeFormatHourOnlyToShow : appConfig.Formats.TimeFormat }}"
      formControlName="{{ controlName }}"
    />
  </div>

  <ng-content> </ng-content>

  <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="basic-link">
    <li>
      <timepicker
        [max]="max"
        [minuteStep]="showHoursOnly ? 60 : dateTimeStepMin"
        [min]="min"
        [showMeridian]="true"
        [showMinutes]="!showHoursOnly"
        [showSeconds]="false"
        [hourStep]="1"
        [meridians]="['AM', 'PM']"
        formControlName="{{ controlNameSelector }}"
      ></timepicker>
    </li>
    <div class="dropdown-divider mb-3"></div>
    <button type="button" (click)="time.hide()" class="btn btn-outline-primary btn-sm btn-block">
      {{ 'APPLY' | translate }}
    </button>
  </ul>
</div>
